import React, { useState, useEffect, useContext} from 'react';
import { Box, Typography, Button, Stack, TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../contexts/AuthContext';
import { setSnackDetails, setMetaData, setGeneral, setSweetAlert } from '../../service/actions/common';
import axios from 'axios';

import { useFormik } from 'formik';
import * as yup from 'yup';

const amountPattern = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
const validationSchema = yup.object({
    price_per_report: yup
        .string('Price Per Report')
        .trim()
        .required('Price Per Report is required')
        .matches(amountPattern, "Price Per Report is not valid"),
    number_of_reports: yup
        .string('Number of Report')
        .trim()
        .required('Number of Report is required')
        .matches(amountPattern, "Number of Report not valid"),
    affiliate_discount: yup
        .string('Affiliate Discount')
        .trim()
        .required('Affiliate Discount is required')
        .matches(amountPattern, "Affiliate Discount not valid"),
    referee_discount: yup
        .string('Referee Discount')
        .trim()
        .required('Referee Discount is required')
        .matches(amountPattern, "Referee Discount not valid"),
    price_percentage: yup
        .string('Price Percentage')
        .trim()
        .required('Price Percentage is required')
        .matches(amountPattern, "Price Percentage not valid"),
    price_per_report_single: yup
        .string('Price Per Report')
        .trim()
        .required('Price Per Report is required')
        .matches(amountPattern, "Price Per Report not valid")
    });

const Setting = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { token, user } = useContext(AuthContext);
    const [isEdit, setIsEdit] = useState(false);
    const general = useSelector((state) => state.general);
    const metaData  = {
        title: 'System Variables | Inspect Reply AI',
		description: 'System Variables | Inspect Reply AI'
    };

    const catchError = async (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                navigate('/sign-in');
            } else if (error.response.status >= 500) {
                dispatch(setSweetAlert({ open: true, title: 'Server Error', text: '' }));
            } else if (error.response.status === 400) {
                dispatch(setSnackDetails({openState : true, message : error.response.data.message, severity : 'error'}));
                return false;
            } else {
                dispatch(setSweetAlert({ open: true, title: 'Error', text: '' }));
            }
        } else if (error.request) {
            dispatch(setSweetAlert({ open: true, title: 'Connection Lost', text: '' }));
        } else {
            dispatch(setSweetAlert({ open: true, title: 'Error', text: 'An unknown error occurred.' }));
        }
    };

    const fetchSetting = async () => {
        if (user && token) {
            try {
                let uri = `/general`;
                const response = await axios.get(uri, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    timeout: 10000, // Timeout after 10 seconds
                });
                dispatch(setGeneral(response.data));
            } catch (error) {
                catchError(error);
            }
        }
      };
    useEffect(() => {
        fetchSetting();
        dispatch(setMetaData(metaData));
        // eslint-disable-next-line
    }, []);
    
    const formik = useFormik({
        initialValues: {
            general_id: general?._id,
            price_per_report: general?.price_per_report,
            number_of_reports: general?.number_of_reports,
            price_per_report_single: general?.price_per_report_single,
            affiliate_discount: general?.affiliate_discount,
            referee_discount: general?.referee_discount,
            price_percentage: general?.price_percentage,
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                if (user && token ) {
                    const response = await axios.post('/update-general', values, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        },
                    });
                    if (response.status === 200) {
                        dispatch(setGeneral(response.data.general));
                        dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'success'}));
                        setIsEdit(false);
                    } else {
                        dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'error'}));
                    }
                } else {
                    console.log('unauthorized');
                }
            } catch (error) {
                catchError();
            }
        },
    });

  return (
    <Box>
        <Stack direction="row" justifyContent="flex-start" sx={{ width: '100%' }}>
             <Typography variant="h4">System Variables</Typography>  
            { isEdit ? (
            <Button color="primary" variant="contained" onClick={formik.handleSubmit} sx={{ borderRadius: 28, ml: "auto" }} >
                Save
            </Button>
            ) : (
            <Button color="primary" variant="outlined" onClick={(e) => {setIsEdit(true)}} sx={{ borderRadius: 28, ml: "auto" }} >
                Edit
            </Button>
            )}
        </Stack>
        <Box
            sx={{
                margin: 'auto',
                padding: 2,
                gap: 2,
                border: '1px solid #ddd',
                borderRadius: 2,
                boxShadow: 1,
                mt:2,
                backgroundColor:'#FFF'
            }}
        >

        <Stack spacing={2} sx={{ minHeight: '70vh'}}>    
        <Typography variant="p">BULK PRICING</Typography>

        <Stack direction="row" justifyContent="flex-start" spacing={2}>
            <TextField
                label="Number Of Reports"
                name="number_of_reports"
                id="number_of_reports"
                type="text"
                variant='outlined'
                disabled={!isEdit}
                InputLabelProps={{ shrink: true }}
                value={formik.values.number_of_reports}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.number_of_reports && Boolean(formik.errors.number_of_reports)}
                helperText={formik.touched.number_of_reports && formik.errors.number_of_reports}

            />

            <TextField
                label="Price per report"
                name="price_per_report"
                id="price_per_report"
                type="text"
                variant='outlined'
                disabled={!isEdit}
                InputLabelProps={{ shrink: true }}
                value={formik.values.price_per_report}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.price_per_report && Boolean(formik.errors.price_per_report)}
                helperText={formik.touched.price_per_report && formik.errors.price_per_report}
                InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
            />

        </Stack>
        <Typography style={{ marginTop: '35px' }} variant="p">SINGLE REPORT PRICING</Typography>
        <Stack direction="row" justifyContent="flex-start" spacing={2}>
            <TextField
                label="Price Per Report"
                name="price_per_report_single"
                id="price_per_report_single"
                type="text"
                variant='outlined'
                disabled={!isEdit}
                InputLabelProps={{ shrink: true }}
                value={formik.values.price_per_report_single}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.price_per_report_single && Boolean(formik.errors.price_per_report_single)}
                helperText={formik.touched.price_per_report_single && formik.errors.price_per_report_single}
                InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
            />
        </Stack> 


        <Typography style={{ marginTop: '35px' }} variant="p">AFFILIATE PROGRAM</Typography>
        <Stack direction="row" justifyContent="flex-start" spacing={2}>
            <TextField
                label="Affiliate Discount"
                name="affiliate_discount"
                id="affiliate_discount"
                type="text"
                variant='outlined'
                disabled={!isEdit}
                InputLabelProps={{ shrink: true }}
                value={formik.values.affiliate_discount}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.affiliate_discount && Boolean(formik.errors.affiliate_discount)}
                helperText={formik.touched.affiliate_discount && formik.errors.affiliate_discount}
                InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
            />
            <TextField
                label="Referee Discount"
                name="referee_discount"
                id="referee_discount"
                type="text"
                variant='outlined'
                disabled={!isEdit}
                InputLabelProps={{ shrink: true }}
                value={formik.values.referee_discount}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.referee_discount && Boolean(formik.errors.referee_discount)}
                helperText={formik.touched.referee_discount && formik.errors.referee_discount}
                InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
            />
        </Stack>

        <Typography style={{ marginTop: '35px' }} variant="p">MEDIAN REPAIR COST PERCENTAGE</Typography>
        <Stack direction="row" justifyContent="flex-start" spacing={2}>
            <TextField
                label="Price Percentage"
                name="price_percentage"
                id="price_percentage"
                type="text"
                variant='outlined'
                disabled={!isEdit}
                InputLabelProps={{ shrink: true }}
                value={formik.values.price_percentage}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.price_percentage && Boolean(formik.errors.price_percentage)}
                helperText={formik.touched.price_percentage && formik.errors.price_percentage}
                InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
            />
        </Stack>

        </Stack>       
    </Box>
    </Box>
  );
};

export default Setting;